import {AdditionalLinks} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/AdditionalLinks/AdditionalLinks';
import {Cohost} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Cohost/Cohost';
import {GuestsOfHonor} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/GuestOfHonor/GuestsOfHonor';
import {Host} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Host/Host';
import {HostContact} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/HostContact/HostContact';
import {HostMessage} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/HostMessage/HostMessage';
import {Section} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Section/Section';
import {Title} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Title/Title';
import {WhenFields} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/WhenFields/WhenFields';
import {WhereFields} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/WhereFields/WhereFields';
import {Rsvps} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/Rsvps/Rsvps';
import {Divider} from '~library/atoms/Divider';

import './DetailsFields.sass';

export const DetailsFields = () => (
  <div className="details-fields" id="details-section">
    <Section title="Title*">
      <Title />
    </Section>

    <div className="details-fields__ww-section">
      <Section title="When*">
        <WhenFields />
      </Section>

      <Section title="Where">
        <WhereFields />
      </Section>
    </div>

    <Divider />

    <Section title="Hosted By*">
      <Host />
      <HostMessage />
    </Section>

    <HostContact />

    <AdditionalLinks />

    <Cohost />

    <GuestsOfHonor />

    <Rsvps />
  </div>
);
